import { IAnnualReport, IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { I18NextService } from 'angular-i18next';
import { IOptions, ISectionData } from '../../../../aumico-lib-annualreport-fe/src/lib';
import { ArFeatureBaseModel } from './arFeatureBase.model';
import { ArFeatureBasePDFSectionFactory } from './arFeatureBasePdfSection.factory';

export abstract class ArFeatureBasePDFSectionBaseFactory<Model extends ArFeatureBaseModel>
    implements ArFeatureBasePDFSectionFactory<Model>
{
    constructor(protected i18nextService: I18NextService) {}
    abstract createSectionWithDefaultOptions(domainModel: Model): ISectionData;
    abstract createSection(
        annualReport: IAnnualReport,
        printOptions: IPrintOptions,
        annualReportForAutofill: IAnnualReport,
        reportOrder: string[],
        options: IOptions,
        predifinedLables: Map<string, string>,
        formatLocale: string,
        translationLocale: string,
        reportLocale: string,
    ): ISectionData;
}
